import moment from 'moment';

export class PeriodeParametrageFacturation {
  id: number;
  dateDebut: Date;
  prixVenteHT: number;
  periodeToDelete: boolean;
}

/**
 * Applique un prix de vente ou un taux de revalorisation à la période démarrant à `dateDebut` : modifie la période
 * existante à cette date si elle existe, sinon en crée une nouvelle à partir du dernier prix connu et invalide
 * (`periodeToDelete`) les périodes déjà planifiées après elle. `null` signale l'absence de prix de référence pour
 * appliquer un taux (aucune période existante à cette date, aucune période antérieure). La nouvelle période
 * reprend les champs de `dernierePeriode` (utile pour un type dérivé portant des champs additionnels, ex.
 * PeriodeParametrageFacturationProduitComplementaire) avant d'écraser id/dateDebut/prixVenteHT/periodeToDelete.
 */
export function applyTauxOrPrixToPeriodeList<T extends PeriodeParametrageFacturation>(periodeList: T[], dateDebut: Date,
                                                                                       prixVenteHT: number, taux: number): T[] | null {
  const index = periodeList.findIndex(periode => moment(periode.dateDebut).isSame(dateDebut, 'day'));

  if (index !== -1) {
    const nouveauPrix = taux != null ? periodeList[index].prixVenteHT * ((taux / 100) + 1) : prixVenteHT;
    return periodeList.map((periode, i) => i === index ? {...periode, prixVenteHT: nouveauPrix, periodeToDelete: false} as T : periode);
  }

  const dernierePeriode = periodeList.length > 0
    ? [...periodeList].sort((a, b) => moment(b.dateDebut).diff(a.dateDebut, 'day'))[0]
    : null;
  if (taux != null && !dernierePeriode) {
    return null;
  }
  const nouveauPrix = taux != null ? dernierePeriode.prixVenteHT * ((taux / 100) + 1) : prixVenteHT;

  const sortedList = [...periodeList, {...(dernierePeriode ?? {}), id: null, dateDebut, prixVenteHT: nouveauPrix, periodeToDelete: false} as T]
    .sort((a, b) => moment(a.dateDebut).diff(b.dateDebut, 'day'));
  const insertionIndex = sortedList.findIndex(periode => moment(periode.dateDebut).isSame(dateDebut, 'day'));
  return sortedList.map((periode, i) => ({...periode, periodeToDelete: i > insertionIndex} as T));
}
